import React, { Component } from 'react';
import '../myutils';
import {
  translate,
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatar from '@material-ui/core/Avatar';
import PlayIcon from '@material-ui/icons/PlayArrow';
import icons from '../res/icons'
export const TemplateIcon = BookIcon;

class TreeItem extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      record: false
    }
  }

  render() {               
    var icon; 
    if (this.props.record.fileType === 'BIN' && /(.*).mp3/.test(this.props.record.name)) icon = <PlayIcon />
    else if (this.props.record.fileType === 'EXT') icon = icons[this.props.record.extType];
    else icon = icons[this.props.record.fileType];
    return (
      <Avatar className={styles.avatar}>{icon}</Avatar>
    )
  }
}

TreeItem.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.array.isRequired,
  push: PropTypes.func,
  showNotification: PropTypes.func,
};

const styles = {
  avatar: {
    margin: 10,
  }
};

export default connect(null, {
  push: pushAction,
})(translate(TreeItem));